import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import Typography from 'brandComponents/Typography';

import {OrderAddressProps} from './IOrderAddress';

import styles from './OrderAddress.module.scss';

const OrderAddress = ({address, addressLabel}: OrderAddressProps) => {
	const intl = useIntl();
	const countryCode = address.getCountryCode();
	const countryTranslation = { //TODO: understand if makes sense to move to model
		id: `country.${countryCode}`,
		defaultMessage: countryCode,
	};

	return (
		<div className={cn(styles['order-address'], 'order-address')}>
			<Typography variant="h6">{addressLabel}</Typography>
			<span>{address.getFullName()}</span>
			<span>{address.getAddress1()}</span>
			<span>{address.getPostalCode()}</span>
			<span>
				{address.getCity()} - {intl.formatMessage(countryTranslation)}
			</span>
		</div>
	);
};

export default OrderAddress;
